(function () {
  const widget = document.querySelector('.floating-inquiry');
  if (!widget) return;

  const trigger = widget.querySelector('.floating-inquiry-trigger');
  const panel = widget.querySelector('.floating-inquiry-panel');
  const dragHandle = widget.querySelector('.floating-inquiry-head');
  const footerTarget = document.querySelector('#footer-inquiry');
  const storageKey = 'parkhouseFloatingInquiryTopV29';
  const dragThreshold = 3;
  const margin = 16;
  const closeDelay = 180;
let closeTimer = null;
  let isPointerDown = false;
  let isDragging = false;
  let movedDuringPress = false;
  let activePointerId = null;
  let startPointerY = 0;
  let startCenterY = 0;
  let startedOnTrigger = false;
  let suppressNextClick = false;

  function isMobileLayout() {
    return window.matchMedia('(max-width: 800px)').matches;
  }

  function openWidget() {
    window.clearTimeout(closeTimer);
    widget.classList.add('is-open');
    if (panel) panel.setAttribute('aria-hidden', 'false');
  }

  function closeWidget() {
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      if (isPointerDown || isDragging) return;
      widget.classList.remove('is-open');
      if (panel) panel.setAttribute('aria-hidden', 'true');
    }, closeDelay);
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function getTriggerCenterY() {
    const rect = (trigger || widget).getBoundingClientRect();
    return rect.top + rect.height / 2;
  }

  function getTriggerHeight() {
    const rect = (trigger || widget).getBoundingClientRect();
    return rect.height || 58;
  }

  function setY(centerY, persist) {
    const half = getTriggerHeight() / 2;
    const y = clamp(centerY, margin + half, window.innerHeight - margin - half);

    widget.style.top = Math.round(y) + 'px';
    widget.style.right = isMobileLayout() ? '12px' : '0px';
    widget.style.left = 'auto';
    widget.style.bottom = 'auto';
    widget.style.transform = isMobileLayout() ? 'none' : 'translateY(-50%)';
    widget.classList.add('is-positioned');

    if (persist) {
      try { window.localStorage.setItem(storageKey, String(Math.round(y))); } catch (error) {}
    }
  }

  function restoreInitialY() {
    if (isMobileLayout()) return;
    try {
      const stored = Number(window.localStorage.getItem(storageKey));
      if (Number.isFinite(stored) && stored > 0) {
        setY(stored, false);
        return;
      }
    } catch (error) {}

    // Default at one-third of the viewport height, using the trigger centre point.
    setY(window.innerHeight / 3, false);
  }

  function beginPress(event) {
    const handle = event.target.closest('.floating-inquiry-trigger, .floating-inquiry-head');
    if (!handle || !widget.contains(handle)) return;
    if (event.button !== undefined && event.button !== 0) return;

    window.clearTimeout(closeTimer);
    openWidget();

    isPointerDown = true;
    isDragging = false;
    movedDuringPress = false;
    suppressNextClick = false;
    startedOnTrigger = Boolean(event.target.closest('.floating-inquiry-trigger'));
    activePointerId = event.pointerId;
    startPointerY = event.clientY;
    startCenterY = getTriggerCenterY();

    widget.classList.add('is-pointer-down');

    // Capture on the actual pressed handle, not on the whole widget. This keeps the drag stable.
    if (activePointerId !== undefined && handle.setPointerCapture) {
      try { handle.setPointerCapture(activePointerId); } catch (error) {}
    }

    document.addEventListener('pointermove', handlePointerMove, { passive: false });
    document.addEventListener('pointerup', finishPress, true);
    document.addEventListener('pointercancel', finishPress, true);
  }

  function handlePointerMove(event) {
    if (!isPointerDown) return;

    const deltaY = event.clientY - startPointerY;
    if (!isDragging && Math.abs(deltaY) < dragThreshold) return;

    isDragging = true;
    movedDuringPress = true;
    suppressNextClick = true;
    widget.classList.add('is-dragging', 'is-open');
    if (panel) panel.setAttribute('aria-hidden', 'false');

    if (event.cancelable) event.preventDefault();
    setY(startCenterY + deltaY, false);
  }

  function finishPress(event) {
    if (!isPointerDown) return;

    document.removeEventListener('pointermove', handlePointerMove);
    document.removeEventListener('pointerup', finishPress, true);
    document.removeEventListener('pointercancel', finishPress, true);

    if (movedDuringPress) {
      // Stop exactly at the height where the mouse was released.
      setY(getTriggerCenterY(), true);
      event.preventDefault();
      event.stopPropagation();
      window.setTimeout(function () { suppressNextClick = false; }, 260);
    }

    isPointerDown = false;
    isDragging = false;
    widget.classList.remove('is-pointer-down', 'is-dragging');

    // Normal press/click on the trigger means jump to the inquiry form.
    if (!movedDuringPress && startedOnTrigger) {
      scrollToInquiry();
    }

    window.setTimeout(function () {
      movedDuringPress = false;
      startedOnTrigger = false;
    }, 0);
  }

  function scrollToInquiry(event) {
    if (event) event.preventDefault();
    if (suppressNextClick || movedDuringPress) return;
    if (!footerTarget) return;

    footerTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const firstInput = footerTarget.querySelector('input, textarea, button');
    if (firstInput) {
      window.setTimeout(function () { firstInput.focus({ preventScroll: true }); }, 520);
    }
  }

  widget.addEventListener('pointerenter', openWidget);
  widget.addEventListener('pointerleave', closeWidget);
  widget.addEventListener('focusin', openWidget);
  widget.addEventListener('focusout', closeWidget);

  if (trigger) {
    trigger.addEventListener('pointerdown', beginPress);
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      if (suppressNextClick || movedDuringPress) return;
      scrollToInquiry();
    });
  }
  if (dragHandle) dragHandle.addEventListener('pointerdown', beginPress);

  widget.querySelectorAll('a[href="#footer-inquiry"]').forEach(function (link) {
    link.addEventListener('click', scrollToInquiry);
  });

  window.addEventListener('resize', function () {
    if (isMobileLayout()) return;
    setY(getTriggerCenterY(), true);
  });

  restoreInitialY();
})();
